import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Flow } from '../libs';
import { THIRD_LOGIN, THIRD_SEND_EMAIL_CODE, THIRD_BIND_EMAIL, BIND_UID_ACCOUNT, LOGIN_AND_BIND_TOKEN, THIRD_SEND_MOBILE_CODE, THIRD_BIND_MOBILE } from '../constants';

/**
 * 第三方登录注册流程
 * @link https://shopline.yuque.com/sczv0i/zbwfmf/lk26ce
 */
export var ThirdLoginFlow = /*#__PURE__*/function (_Flow) {
  _inherits(ThirdLoginFlow, _Flow);

  var _super = _createSuper(ThirdLoginFlow);

  function ThirdLoginFlow() {
    _classCallCheck(this, ThirdLoginFlow);

    return _super.apply(this, arguments);
  }

  _createClass(ThirdLoginFlow, [{
    key: "thirdLoginAndBindEmail",
    value:
    /** 第三方登录 */
    function () {
      var _thirdLoginAndBindEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.request(THIRD_LOGIN, params));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function thirdLoginAndBindEmail(_x) {
        return _thirdLoginAndBindEmail.apply(this, arguments);
      }

      return thirdLoginAndBindEmail;
    }()
    /** 三方登录 绑定三方登录账号与uid接口 */

  }, {
    key: "thirdLoginAndBindToken",
    value: function () {
      var _thirdLoginAndBindToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.request(LOGIN_AND_BIND_TOKEN, params));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function thirdLoginAndBindToken(_x2) {
        return _thirdLoginAndBindToken.apply(this, arguments);
      }

      return thirdLoginAndBindToken;
    }()
    /** 三方登录 发送邮箱验证码 */

  }, {
    key: "thirdSendEmailCode",
    value: function () {
      var _thirdSendEmailCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.request(THIRD_SEND_EMAIL_CODE, params));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function thirdSendEmailCode(_x3) {
        return _thirdSendEmailCode.apply(this, arguments);
      }

      return thirdSendEmailCode;
    }()
    /** 三方登录 绑定邮箱 */

  }, {
    key: "thirdBindEmail",
    value: function () {
      var _thirdBindEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.request(THIRD_BIND_EMAIL, params));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function thirdBindEmail(_x4) {
        return _thirdBindEmail.apply(this, arguments);
      }

      return thirdBindEmail;
    }()
    /** 三方登录 发送手机验证码 */

  }, {
    key: "thirdSendMobileCode",
    value: function () {
      var _thirdSendMobileCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.request(THIRD_SEND_MOBILE_CODE, params));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function thirdSendMobileCode(_x5) {
        return _thirdSendMobileCode.apply(this, arguments);
      }

      return thirdSendMobileCode;
    }()
    /** 三方登录 验证手机验证码并绑定手机账号和三方登录 */

  }, {
    key: "thirdBindMobile",
    value: function () {
      var _thirdBindMobile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.request(THIRD_BIND_MOBILE, params));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function thirdBindMobile(_x6) {
        return _thirdBindMobile.apply(this, arguments);
      }

      return thirdBindMobile;
    }()
    /** 三方登录 绑定三方登录账号与uid接口 */

  }, {
    key: "BindUidAccount",
    value: function () {
      var _BindUidAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.request(BIND_UID_ACCOUNT, params));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function BindUidAccount(_x7) {
        return _BindUidAccount.apply(this, arguments);
      }

      return BindUidAccount;
    }()
    /** 绑定三方登录与当前登录账号 */

  }, {
    key: "thirdBindLoginAccount",
    value: function () {
      var _thirdBindLoginAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.request('/lgn/third/open/bindLoginAccount.do', params));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function thirdBindLoginAccount(_x8) {
        return _thirdBindLoginAccount.apply(this, arguments);
      }

      return thirdBindLoginAccount;
    }()
  }]);

  return ThirdLoginFlow;
}(Flow);

_defineProperty(ThirdLoginFlow, "flowName", 'ThirdLoginFlow');